// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.dashboard-theme-dark .dashboard-tab-content {
  background: rgba(10, 15, 28, 0.92) !important;
  color: #e2e8f0 !important;
}

.dashboard-theme-dark .dashboard-tab-content * {
  scrollbar-color: #334155 #0b1220;
}

.dashboard-theme-dark .dashboard-tab-content ::selection {
  background: #2563eb;
  color: #f8fafc;
}

html[data-theme='dark'] ::selection {
  background: #2563eb;
  color: #f8fafc;
}

.dashboard-theme-dark .dashboard-tab-content :is(
    div,
    section,
    article,
    aside,
    header,
    footer,
    main,
    form,
    fieldset
  )[class*="bg-"],
.dashboard-theme-dark .dashboard-tab-content [class*="card"],
.dashboard-theme-dark .dashboard-tab-content [class*="panel"],
.dashboard-theme-dark .dashboard-tab-content [class*="container"] {
  background-color: #090e1c !important;
  border-color: #334155 !important;
  color: #e2e8f0 !important;
}

.dashboard-theme-dark .dashboard-tab-content :is(input, textarea, select) {
  background-color: #0f172a !important;
  border-color: #334155 !important;
  color: #e2e8f0 !important;
}

.dashboard-theme-dark .dashboard-tab-content :is(input, textarea, select)::placeholder {
  color: #94a3b8 !important;
}

.dashboard-theme-dark .dashboard-tab-content :is(button, [role="button"]) {
  border-color: #334155;
}

.dashboard-theme-dark .dashboard-tab-content a {
  color: #93c5fd !important;
}

.dashboard-theme-dark .dashboard-tab-content [class*="text-slate-"],
.dashboard-theme-dark .dashboard-tab-content [class*="text-gray-"],
.dashboard-theme-dark .dashboard-tab-content [class*="text-zinc-"],
.dashboard-theme-dark .dashboard-tab-content [class*="text-neutral-"] {
  color: #e2e8f0 !important;
}

.dashboard-theme-dark .dashboard-tab-content [class*="bg-white"],
.dashboard-theme-dark .dashboard-tab-content [class*="bg-slate-0"],
.dashboard-theme-dark .dashboard-tab-content [class*="bg-slate-1"],
.dashboard-theme-dark .dashboard-tab-content [class*="bg-slate-5"],
.dashboard-theme-dark .dashboard-tab-content [class*="bg-gray-0"],
.dashboard-theme-dark .dashboard-tab-content [class*="bg-gray-1"],
.dashboard-theme-dark .dashboard-tab-content [class*="bg-gray-5"],
.dashboard-theme-dark .dashboard-tab-content [class*="bg-zinc-5"],
.dashboard-theme-dark .dashboard-tab-content [class*="bg-neutral-5"],
.dashboard-theme-dark .dashboard-tab-content [class*="from-white"],
.dashboard-theme-dark .dashboard-tab-content [class*="to-white"] {
  background: #111b31 !important;
}

.dashboard-theme-dark .dashboard-tab-content img:not([src*=".svg"]),
.dashboard-theme-dark .dashboard-tab-content video,
.dashboard-theme-dark .dashboard-tab-content canvas {
  filter: brightness(0.9) contrast(1.05);
}


.dashboard-theme-dark .dashboard-tab-content {
  --dashboard-dark-surface: #111b31;
  --dashboard-dark-selected-surface: #090e1c;
}

.dashboard-theme-dark .dashboard-tab-content .dashboard-metric-card,
.dashboard-theme-dark .dashboard-tab-content .dashboard-tasks-shell,
.dashboard-theme-dark .dashboard-tab-content .dashboard-process-wrapper,
.dashboard-theme-dark .dashboard-tab-content .dashboard-process-card,
.dashboard-theme-dark .dashboard-tab-content .dashboard-process-card [class*="bg-gradient-to-r"],
.dashboard-theme-dark .dashboard-tab-content .dashboard-process-card [class*="bg-blue-50"],
.dashboard-theme-dark .dashboard-tab-content .dashboard-process-card [class*="from-blue-"],
.dashboard-theme-dark .dashboard-tab-content .dashboard-process-card [class*="via-blue-"],
.dashboard-theme-dark .dashboard-tab-content .dashboard-process-card [class*="to-transparent"] {
  background: var(--dashboard-dark-surface) !important;
  background-image: none !important;
  border-color: var(--dashboard-dark-surface) !important;
}

.dashboard-theme-dark .dashboard-tab-content .dashboard-tasks-shell {
  box-shadow: none !important;
  border-color: transparent !important;
}

.dashboard-theme-dark .dashboard-tab-content .dashboard-tasks-column {
  box-shadow: none !important;
  border-color: transparent !important;
}

.dashboard-theme-dark .dashboard-tab-content .dashboard-metric-card {
  color: #f8fafc !important;
  --tw-ring-color: #090e1c !important;
  --tw-ring-offset-color: #090e1c !important;
  --tw-ring-offset-width: 0px !important;
}

.dashboard-theme-dark .dashboard-tab-content .dashboard-metric-card[aria-pressed="true"] {
  background: var(--dashboard-dark-selected-surface) !important;
  background-image: none !important;
}

.dashboard-theme-dark .dashboard-tab-content .dashboard-metric-card p,
.dashboard-theme-dark .dashboard-tab-content .dashboard-metric-card span,
.dashboard-theme-dark .dashboard-tab-content .dashboard-metric-card svg {
  color: inherit !important;
}

.dashboard-theme-dark .dashboard-tab-content .dashboard-metric-card [class*="rounded-xl"] {
  background: var(--dashboard-dark-surface) !important;
}


.dashboard-theme-dark .dashboard-tab-content .dashboard-metric-card .dashboard-metric-icon--tasks {
  color: #3b82f6 !important;
}

.dashboard-theme-dark .dashboard-tab-content .dashboard-metric-card .dashboard-metric-icon--on-time {
  color: #10b981 !important;
}

.dashboard-theme-dark .dashboard-tab-content .dashboard-metric-card .dashboard-metric-icon--alert {
  color: #fbbf24 !important;
}

.dashboard-theme-dark .dashboard-tab-content .dashboard-metric-card .dashboard-metric-icon--late {
  color: #ef4444 !important;
}

.dashboard-theme-dark .dashboard-tab-content .dashboard-process-name {
  color: #ffffff !important;
}


.dashboard-theme-dark .dashboard-tab-content .dashboard-task-open-button {
  background-color: #2563eb !important;
  color: #ffffff !important;
  border-width: 0 !important;
  border-radius: 9999px !important;
  border-color: transparent !important;
  padding: 0.25rem 0.75rem !important;
  font-size: 0.875rem !important;
  font-weight: 600 !important;
  line-height: 1.25rem !important;
  box-shadow: 0 4px 6px -1px rgb(0 0 0 / 0.1), 0 2px 4px -2px rgb(0 0 0 / 0.1) !important;
  transition: background-color 0.2s ease !important;
}

.dashboard-theme-dark .dashboard-tab-content .dashboard-task-open-button:hover {
  background-color: #1d4ed8 !important;
}

.dashboard-theme-dark .dashboard-tab-content .djs-connection .djs-visual > :nth-child(1),
.dashboard-theme-dark .dashboard-tab-content .djs-connection .djs-outline {
  stroke: #ffffff !important;
}

.dashboard-theme-dark .dashboard-tab-content .djs-container svg defs marker path {
  fill: #ffffff !important;
  stroke: #ffffff !important;
}

html[data-theme='dark'] .djs-connection .djs-visual > :nth-child(1),
html[data-theme='dark'] .djs-connection .djs-outline {
  stroke: #ffffff !important;
}

html[data-theme='dark'] .djs-container svg defs marker path {
  fill: #ffffff !important;
  stroke: #ffffff !important;
}

html[data-theme='dark'] .modal-portal .modal-surface {
  background-color: #0b1220 !important;
  border: 1px solid #1e293b;
  color: #f8fafc !important;
}

html[data-theme='dark'] .modal-portal :is(h1, h2, h3, h4, h5, h6, label, span, p, dt, dd, small) {
  color: #f8fafc !important;
}

html[data-theme='dark'] .modal-portal :is(input, textarea, select) {
  background-color: #1e3a8a !important;
  border-color: #3b82f6 !important;
  color: #f8fafc !important;
}

html[data-theme='dark'] .modal-portal :is(input, textarea, select)::placeholder {
  color: #bfdbfe !important;
}

html[data-theme='dark'] .modal-portal :is([class*='bg-white'], [class*='bg-slate-50'], [class*='bg-slate-100']) {
  background-color: #0f172a !important;
  border-color: #1e293b !important;
  color: #f8fafc !important;
}

html[data-theme='dark'] .modal-portal button[type='button'] {
  color: #e2e8f0 !important;
  border-color: #475569 !important;
}

html[data-theme='dark'] .modal-portal .mural-compose-form label {
  color: #cbd5e1 !important;
}

html[data-theme='dark'] .modal-portal .mural-editor-toolbar button,
html[data-theme='dark'] .modal-portal .mural-color-picker {
  background: #0f172a !important;
  border-color: #334155 !important;
  color: #e2e8f0 !important;
}

html[data-theme='dark'] .modal-portal .mural-rich-editor {
  background: #0f172a !important;
  border-color: #334155 !important;
  color: #e2e8f0 !important;
}

html[data-theme='dark'] .modal-portal .mural-rich-editor:empty::before {
  color: #94a3b8 !important;
}

html[data-theme='dark'] .modal-portal .mural-form-actions button.secondary {
  background: #1e293b !important;
  border-color: #475569 !important;
  color: #e2e8f0 !important;
}

html[data-theme='dark'] .modal-portal .bg-blue-100 {
  background-color: #1e3a8a !important;
  color: #bfdbfe !important;
}

html[data-theme='dark'] .modal-portal .bg-emerald-100 {
  background-color: #065f46 !important;
  color: #a7f3d0 !important;
}

html[data-theme='dark'] .modal-portal .bg-rose-100 {
  background-color: #7f1d1d !important;
  color: #fecdd3 !important;
}

html[data-theme='dark'] .modal-portal .bg-amber-100 {
  background-color: #78350f !important;
  color: #fde68a !important;
}

html[data-theme='dark'] .modal-portal .bg-slate-200 {
  background-color: #334155 !important;
  color: #e2e8f0 !important;
}

html[data-theme='dark'] .modal-portal :is(.bg-blue-100, .bg-emerald-100, .bg-rose-100, .bg-amber-100, .bg-slate-200)
  :is(span, p, small, svg) {
  color: inherit !important;
}

/* New Request tab explicit dark theme overrides */
.dashboard-theme-dark .dashboard-tab-content .new-request-tab-shell {
  background: #0b1220 !important;
}

.dashboard-theme-dark .dashboard-tab-content .new-request-tab-header,
.dashboard-theme-dark .dashboard-tab-content .new-request-tab-state,
.dashboard-theme-dark .dashboard-tab-content .new-request-category-header,
.dashboard-theme-dark .dashboard-tab-content .new-request-process-card,
.dashboard-theme-dark .dashboard-tab-content .new-request-schedule-panel {
  background: #111827 !important;
  border-color: #334155 !important;
}

.dashboard-theme-dark .dashboard-tab-content .new-request-tab-search {
  background: #0f172a !important;
  border-color: #334155 !important;
}

.dashboard-theme-dark .dashboard-tab-content .new-request-tab-shell :is(h1, h2, h3, p, label) {
  color: #f8fafc !important;
}

.dashboard-theme-dark .dashboard-tab-content .new-request-tab-shell input,
.dashboard-theme-dark .dashboard-tab-content .new-request-tab-shell input::placeholder {
  color: #e2e8f0 !important;
}

.dashboard-theme-dark .dashboard-tab-content .new-request-process-card .text-slate-900,
.dashboard-theme-dark .dashboard-tab-content .new-request-process-card .text-blue-600,
.dashboard-theme-dark .dashboard-tab-content .new-request-tab-header .text-slate-900,
.dashboard-theme-dark .dashboard-tab-content .new-request-category-header .text-slate-900,
.dashboard-theme-dark .dashboard-tab-content .new-request-category-header .text-blue-500 {
  color: #f8fafc !important;
}

.dashboard-theme-dark .dashboard-tab-content .new-request-process-card {
  background: #0f1b33 !important;
  border-color: #31425f !important;
}

.dashboard-theme-dark .dashboard-tab-content .new-request-process-card .new-request-process-id {
  background: rgba(147, 197, 253, 0.22) !important;
  color: #bfdbfe !important;
}

.dashboard-theme-dark .dashboard-tab-content .new-request-category-badge {
  background: rgba(16, 185, 129, 0.2) !important;
  border-color: rgba(110, 231, 183, 0.45) !important;
  color: #bbf7d0 !important;
}


html[data-theme='dark'] .new-request-tab-shell {
  background: #0b1220 !important;
}

html[data-theme='dark'] :is(.new-request-tab-header, .new-request-tab-state, .new-request-category-header, .new-request-process-card, .new-request-schedule-panel) {
  background: #111827 !important;
  border-color: #334155 !important;
}

html[data-theme='dark'] .new-request-tab-search {
  background: #0f172a !important;
  border-color: #334155 !important;
}

html[data-theme='dark'] .new-request-tab-shell :is(h1, h2, h3, p, label) {
  color: #f8fafc !important;
}

html[data-theme='dark'] .new-request-process-card .text-slate-900,
html[data-theme='dark'] .new-request-process-card .text-blue-600,
html[data-theme='dark'] .new-request-tab-header .text-slate-900,
html[data-theme='dark'] .new-request-category-header .text-slate-900,
html[data-theme='dark'] .new-request-category-header .text-blue-500 {
  color: #f8fafc !important;
}

html[data-theme='dark'] .new-request-process-card {
  background: #0f1b33 !important;
  border-color: #31425f !important;
}

html[data-theme='dark'] .new-request-process-card .new-request-process-id {
  background: rgba(147, 197, 253, 0.22) !important;
  color: #bfdbfe !important;
}

html[data-theme='dark'] .new-request-category-badge {
  background: rgba(16, 185, 129, 0.2) !important;
  border-color: rgba(110, 231, 183, 0.45) !important;
  color: #bbf7d0 !important;
}

/* Form Builder dark theme readability */
html[data-theme='dark'] .form-builder-page :is(
  [class*='text-blue-'],
  [class*='text-slate-9'],
  [class*='text-slate-8'],
  [class*='text-slate-7'],
  [class*='text-slate-6'],
  [class*='text-slate-5']
) {
  color: #f8fafc !important;
}

html[data-theme='dark'] .form-builder-page .form-builder-option-chip {
  color: #1e3a8a !important;
}
`, "",{"version":3,"sources":["webpack://./src/styles/darkMode.css"],"names":[],"mappings":"AAAA;EACE,6CAA6C;EAC7C,yBAAyB;AAC3B;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;;;;;;;;;;;;;;EAcE,oCAAoC;EACpC,gCAAgC;EAChC,yBAAyB;AAC3B;;AAEA;EACE,oCAAoC;EACpC,gCAAgC;EAChC,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;;;;EAIE,yBAAyB;AAC3B;;AAEA;;;;;;;;;;;EAWE,8BAA8B;AAChC;;AAEA;;;EAGE,sCAAsC;AACxC;;;AAGA;EACE,iCAAiC;EACjC,0CAA0C;AAC5C;;AAEA;;;;;;;;;EASE,oDAAoD;EACpD,iCAAiC;EACjC,sDAAsD;AACxD;;AAEA;EACE,2BAA2B;EAC3B,oCAAoC;AACtC;;AAEA;EACE,2BAA2B;EAC3B,oCAAoC;AACtC;;AAEA;EACE,yBAAyB;EACzB,mCAAmC;EACnC,0CAA0C;EAC1C,sCAAsC;AACxC;;AAEA;EACE,6DAA6D;EAC7D,iCAAiC;AACnC;;AAEA;;;EAGE,yBAAyB;AAC3B;;AAEA;EACE,oDAAoD;AACtD;;;AAGA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;;AAGA;EACE,oCAAoC;EACpC,yBAAyB;EACzB,0BAA0B;EAC1B,gCAAgC;EAChC,oCAAoC;EACpC,mCAAmC;EACnC,8BAA8B;EAC9B,2BAA2B;EAC3B,+BAA+B;EAC/B,uFAAuF;EACvF,iDAAiD;AACnD;;AAEA;EACE,oCAAoC;AACtC;;AAEA;;EAEE,0BAA0B;AAC5B;;AAEA;EACE,wBAAwB;EACxB,0BAA0B;AAC5B;;AAEA;;EAEE,0BAA0B;AAC5B;;AAEA;EACE,wBAAwB;EACxB,0BAA0B;AAC5B;;AAEA;EACE,oCAAoC;EACpC,yBAAyB;EACzB,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,oCAAoC;EACpC,gCAAgC;EAChC,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,oCAAoC;EACpC,gCAAgC;EAChC,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,gCAAgC;AAClC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;;EAEE,8BAA8B;EAC9B,gCAAgC;EAChC,yBAAyB;AAC3B;;AAEA;EACE,8BAA8B;EAC9B,gCAAgC;EAChC,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,8BAA8B;EAC9B,gCAAgC;EAChC,yBAAyB;AAC3B;;AAEA;EACE,oCAAoC;EACpC,yBAAyB;AAC3B;;AAEA;EACE,oCAAoC;EACpC,yBAAyB;AAC3B;;AAEA;EACE,oCAAoC;EACpC,yBAAyB;AAC3B;;AAEA;EACE,oCAAoC;EACpC,yBAAyB;AAC3B;;AAEA;EACE,oCAAoC;EACpC,yBAAyB;AAC3B;;AAEA;;EAEE,yBAAyB;AAC3B;;AAEA,kDAAkD;AAClD;EACE,8BAA8B;AAChC;;AAEA;;;;;EAKE,8BAA8B;EAC9B,gCAAgC;AAClC;;AAEA;EACE,8BAA8B;EAC9B,gCAAgC;AAClC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;;EAEE,yBAAyB;AAC3B;;AAEA;;;;;EAKE,yBAAyB;AAC3B;;AAEA;EACE,8BAA8B;EAC9B,gCAAgC;AAClC;;AAEA;EACE,gDAAgD;EAChD,yBAAyB;AAC3B;;AAEA;EACE,8CAA8C;EAC9C,kDAAkD;EAClD,yBAAyB;AAC3B;;;AAGA;EACE,8BAA8B;AAChC;;AAEA;EACE,8BAA8B;EAC9B,gCAAgC;AAClC;;AAEA;EACE,8BAA8B;EAC9B,gCAAgC;AAClC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;;;;;EAKE,yBAAyB;AAC3B;;AAEA;EACE,8BAA8B;EAC9B,gCAAgC;AAClC;;AAEA;EACE,gDAAgD;EAChD,yBAAyB;AAC3B;;AAEA;EACE,8CAA8C;EAC9C,kDAAkD;EAClD,yBAAyB;AAC3B;;AAEA,wCAAwC;AACxC;;;;;;;;EAQE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B","sourcesContent":[".dashboard-theme-dark .dashboard-tab-content {\n  background: rgba(10, 15, 28, 0.92) !important;\n  color: #e2e8f0 !important;\n}\n\n.dashboard-theme-dark .dashboard-tab-content * {\n  scrollbar-color: #334155 #0b1220;\n}\n\n.dashboard-theme-dark .dashboard-tab-content ::selection {\n  background: #2563eb;\n  color: #f8fafc;\n}\n\nhtml[data-theme='dark'] ::selection {\n  background: #2563eb;\n  color: #f8fafc;\n}\n\n.dashboard-theme-dark .dashboard-tab-content :is(\n    div,\n    section,\n    article,\n    aside,\n    header,\n    footer,\n    main,\n    form,\n    fieldset\n  )[class*=\"bg-\"],\n.dashboard-theme-dark .dashboard-tab-content [class*=\"card\"],\n.dashboard-theme-dark .dashboard-tab-content [class*=\"panel\"],\n.dashboard-theme-dark .dashboard-tab-content [class*=\"container\"] {\n  background-color: #090e1c !important;\n  border-color: #334155 !important;\n  color: #e2e8f0 !important;\n}\n\n.dashboard-theme-dark .dashboard-tab-content :is(input, textarea, select) {\n  background-color: #0f172a !important;\n  border-color: #334155 !important;\n  color: #e2e8f0 !important;\n}\n\n.dashboard-theme-dark .dashboard-tab-content :is(input, textarea, select)::placeholder {\n  color: #94a3b8 !important;\n}\n\n.dashboard-theme-dark .dashboard-tab-content :is(button, [role=\"button\"]) {\n  border-color: #334155;\n}\n\n.dashboard-theme-dark .dashboard-tab-content a {\n  color: #93c5fd !important;\n}\n\n.dashboard-theme-dark .dashboard-tab-content [class*=\"text-slate-\"],\n.dashboard-theme-dark .dashboard-tab-content [class*=\"text-gray-\"],\n.dashboard-theme-dark .dashboard-tab-content [class*=\"text-zinc-\"],\n.dashboard-theme-dark .dashboard-tab-content [class*=\"text-neutral-\"] {\n  color: #e2e8f0 !important;\n}\n\n.dashboard-theme-dark .dashboard-tab-content [class*=\"bg-white\"],\n.dashboard-theme-dark .dashboard-tab-content [class*=\"bg-slate-0\"],\n.dashboard-theme-dark .dashboard-tab-content [class*=\"bg-slate-1\"],\n.dashboard-theme-dark .dashboard-tab-content [class*=\"bg-slate-5\"],\n.dashboard-theme-dark .dashboard-tab-content [class*=\"bg-gray-0\"],\n.dashboard-theme-dark .dashboard-tab-content [class*=\"bg-gray-1\"],\n.dashboard-theme-dark .dashboard-tab-content [class*=\"bg-gray-5\"],\n.dashboard-theme-dark .dashboard-tab-content [class*=\"bg-zinc-5\"],\n.dashboard-theme-dark .dashboard-tab-content [class*=\"bg-neutral-5\"],\n.dashboard-theme-dark .dashboard-tab-content [class*=\"from-white\"],\n.dashboard-theme-dark .dashboard-tab-content [class*=\"to-white\"] {\n  background: #111b31 !important;\n}\n\n.dashboard-theme-dark .dashboard-tab-content img:not([src*=\".svg\"]),\n.dashboard-theme-dark .dashboard-tab-content video,\n.dashboard-theme-dark .dashboard-tab-content canvas {\n  filter: brightness(0.9) contrast(1.05);\n}\n\n\n.dashboard-theme-dark .dashboard-tab-content {\n  --dashboard-dark-surface: #111b31;\n  --dashboard-dark-selected-surface: #090e1c;\n}\n\n.dashboard-theme-dark .dashboard-tab-content .dashboard-metric-card,\n.dashboard-theme-dark .dashboard-tab-content .dashboard-tasks-shell,\n.dashboard-theme-dark .dashboard-tab-content .dashboard-process-wrapper,\n.dashboard-theme-dark .dashboard-tab-content .dashboard-process-card,\n.dashboard-theme-dark .dashboard-tab-content .dashboard-process-card [class*=\"bg-gradient-to-r\"],\n.dashboard-theme-dark .dashboard-tab-content .dashboard-process-card [class*=\"bg-blue-50\"],\n.dashboard-theme-dark .dashboard-tab-content .dashboard-process-card [class*=\"from-blue-\"],\n.dashboard-theme-dark .dashboard-tab-content .dashboard-process-card [class*=\"via-blue-\"],\n.dashboard-theme-dark .dashboard-tab-content .dashboard-process-card [class*=\"to-transparent\"] {\n  background: var(--dashboard-dark-surface) !important;\n  background-image: none !important;\n  border-color: var(--dashboard-dark-surface) !important;\n}\n\n.dashboard-theme-dark .dashboard-tab-content .dashboard-tasks-shell {\n  box-shadow: none !important;\n  border-color: transparent !important;\n}\n\n.dashboard-theme-dark .dashboard-tab-content .dashboard-tasks-column {\n  box-shadow: none !important;\n  border-color: transparent !important;\n}\n\n.dashboard-theme-dark .dashboard-tab-content .dashboard-metric-card {\n  color: #f8fafc !important;\n  --tw-ring-color: #090e1c !important;\n  --tw-ring-offset-color: #090e1c !important;\n  --tw-ring-offset-width: 0px !important;\n}\n\n.dashboard-theme-dark .dashboard-tab-content .dashboard-metric-card[aria-pressed=\"true\"] {\n  background: var(--dashboard-dark-selected-surface) !important;\n  background-image: none !important;\n}\n\n.dashboard-theme-dark .dashboard-tab-content .dashboard-metric-card p,\n.dashboard-theme-dark .dashboard-tab-content .dashboard-metric-card span,\n.dashboard-theme-dark .dashboard-tab-content .dashboard-metric-card svg {\n  color: inherit !important;\n}\n\n.dashboard-theme-dark .dashboard-tab-content .dashboard-metric-card [class*=\"rounded-xl\"] {\n  background: var(--dashboard-dark-surface) !important;\n}\n\n\n.dashboard-theme-dark .dashboard-tab-content .dashboard-metric-card .dashboard-metric-icon--tasks {\n  color: #3b82f6 !important;\n}\n\n.dashboard-theme-dark .dashboard-tab-content .dashboard-metric-card .dashboard-metric-icon--on-time {\n  color: #10b981 !important;\n}\n\n.dashboard-theme-dark .dashboard-tab-content .dashboard-metric-card .dashboard-metric-icon--alert {\n  color: #fbbf24 !important;\n}\n\n.dashboard-theme-dark .dashboard-tab-content .dashboard-metric-card .dashboard-metric-icon--late {\n  color: #ef4444 !important;\n}\n\n.dashboard-theme-dark .dashboard-tab-content .dashboard-process-name {\n  color: #ffffff !important;\n}\n\n\n.dashboard-theme-dark .dashboard-tab-content .dashboard-task-open-button {\n  background-color: #2563eb !important;\n  color: #ffffff !important;\n  border-width: 0 !important;\n  border-radius: 9999px !important;\n  border-color: transparent !important;\n  padding: 0.25rem 0.75rem !important;\n  font-size: 0.875rem !important;\n  font-weight: 600 !important;\n  line-height: 1.25rem !important;\n  box-shadow: 0 4px 6px -1px rgb(0 0 0 / 0.1), 0 2px 4px -2px rgb(0 0 0 / 0.1) !important;\n  transition: background-color 0.2s ease !important;\n}\n\n.dashboard-theme-dark .dashboard-tab-content .dashboard-task-open-button:hover {\n  background-color: #1d4ed8 !important;\n}\n\n.dashboard-theme-dark .dashboard-tab-content .djs-connection .djs-visual > :nth-child(1),\n.dashboard-theme-dark .dashboard-tab-content .djs-connection .djs-outline {\n  stroke: #ffffff !important;\n}\n\n.dashboard-theme-dark .dashboard-tab-content .djs-container svg defs marker path {\n  fill: #ffffff !important;\n  stroke: #ffffff !important;\n}\n\nhtml[data-theme='dark'] .djs-connection .djs-visual > :nth-child(1),\nhtml[data-theme='dark'] .djs-connection .djs-outline {\n  stroke: #ffffff !important;\n}\n\nhtml[data-theme='dark'] .djs-container svg defs marker path {\n  fill: #ffffff !important;\n  stroke: #ffffff !important;\n}\n\nhtml[data-theme='dark'] .modal-portal .modal-surface {\n  background-color: #0b1220 !important;\n  border: 1px solid #1e293b;\n  color: #f8fafc !important;\n}\n\nhtml[data-theme='dark'] .modal-portal :is(h1, h2, h3, h4, h5, h6, label, span, p, dt, dd, small) {\n  color: #f8fafc !important;\n}\n\nhtml[data-theme='dark'] .modal-portal :is(input, textarea, select) {\n  background-color: #1e3a8a !important;\n  border-color: #3b82f6 !important;\n  color: #f8fafc !important;\n}\n\nhtml[data-theme='dark'] .modal-portal :is(input, textarea, select)::placeholder {\n  color: #bfdbfe !important;\n}\n\nhtml[data-theme='dark'] .modal-portal :is([class*='bg-white'], [class*='bg-slate-50'], [class*='bg-slate-100']) {\n  background-color: #0f172a !important;\n  border-color: #1e293b !important;\n  color: #f8fafc !important;\n}\n\nhtml[data-theme='dark'] .modal-portal button[type='button'] {\n  color: #e2e8f0 !important;\n  border-color: #475569 !important;\n}\n\nhtml[data-theme='dark'] .modal-portal .mural-compose-form label {\n  color: #cbd5e1 !important;\n}\n\nhtml[data-theme='dark'] .modal-portal .mural-editor-toolbar button,\nhtml[data-theme='dark'] .modal-portal .mural-color-picker {\n  background: #0f172a !important;\n  border-color: #334155 !important;\n  color: #e2e8f0 !important;\n}\n\nhtml[data-theme='dark'] .modal-portal .mural-rich-editor {\n  background: #0f172a !important;\n  border-color: #334155 !important;\n  color: #e2e8f0 !important;\n}\n\nhtml[data-theme='dark'] .modal-portal .mural-rich-editor:empty::before {\n  color: #94a3b8 !important;\n}\n\nhtml[data-theme='dark'] .modal-portal .mural-form-actions button.secondary {\n  background: #1e293b !important;\n  border-color: #475569 !important;\n  color: #e2e8f0 !important;\n}\n\nhtml[data-theme='dark'] .modal-portal .bg-blue-100 {\n  background-color: #1e3a8a !important;\n  color: #bfdbfe !important;\n}\n\nhtml[data-theme='dark'] .modal-portal .bg-emerald-100 {\n  background-color: #065f46 !important;\n  color: #a7f3d0 !important;\n}\n\nhtml[data-theme='dark'] .modal-portal .bg-rose-100 {\n  background-color: #7f1d1d !important;\n  color: #fecdd3 !important;\n}\n\nhtml[data-theme='dark'] .modal-portal .bg-amber-100 {\n  background-color: #78350f !important;\n  color: #fde68a !important;\n}\n\nhtml[data-theme='dark'] .modal-portal .bg-slate-200 {\n  background-color: #334155 !important;\n  color: #e2e8f0 !important;\n}\n\nhtml[data-theme='dark'] .modal-portal :is(.bg-blue-100, .bg-emerald-100, .bg-rose-100, .bg-amber-100, .bg-slate-200)\n  :is(span, p, small, svg) {\n  color: inherit !important;\n}\n\n/* New Request tab explicit dark theme overrides */\n.dashboard-theme-dark .dashboard-tab-content .new-request-tab-shell {\n  background: #0b1220 !important;\n}\n\n.dashboard-theme-dark .dashboard-tab-content .new-request-tab-header,\n.dashboard-theme-dark .dashboard-tab-content .new-request-tab-state,\n.dashboard-theme-dark .dashboard-tab-content .new-request-category-header,\n.dashboard-theme-dark .dashboard-tab-content .new-request-process-card,\n.dashboard-theme-dark .dashboard-tab-content .new-request-schedule-panel {\n  background: #111827 !important;\n  border-color: #334155 !important;\n}\n\n.dashboard-theme-dark .dashboard-tab-content .new-request-tab-search {\n  background: #0f172a !important;\n  border-color: #334155 !important;\n}\n\n.dashboard-theme-dark .dashboard-tab-content .new-request-tab-shell :is(h1, h2, h3, p, label) {\n  color: #f8fafc !important;\n}\n\n.dashboard-theme-dark .dashboard-tab-content .new-request-tab-shell input,\n.dashboard-theme-dark .dashboard-tab-content .new-request-tab-shell input::placeholder {\n  color: #e2e8f0 !important;\n}\n\n.dashboard-theme-dark .dashboard-tab-content .new-request-process-card .text-slate-900,\n.dashboard-theme-dark .dashboard-tab-content .new-request-process-card .text-blue-600,\n.dashboard-theme-dark .dashboard-tab-content .new-request-tab-header .text-slate-900,\n.dashboard-theme-dark .dashboard-tab-content .new-request-category-header .text-slate-900,\n.dashboard-theme-dark .dashboard-tab-content .new-request-category-header .text-blue-500 {\n  color: #f8fafc !important;\n}\n\n.dashboard-theme-dark .dashboard-tab-content .new-request-process-card {\n  background: #0f1b33 !important;\n  border-color: #31425f !important;\n}\n\n.dashboard-theme-dark .dashboard-tab-content .new-request-process-card .new-request-process-id {\n  background: rgba(147, 197, 253, 0.22) !important;\n  color: #bfdbfe !important;\n}\n\n.dashboard-theme-dark .dashboard-tab-content .new-request-category-badge {\n  background: rgba(16, 185, 129, 0.2) !important;\n  border-color: rgba(110, 231, 183, 0.45) !important;\n  color: #bbf7d0 !important;\n}\n\n\nhtml[data-theme='dark'] .new-request-tab-shell {\n  background: #0b1220 !important;\n}\n\nhtml[data-theme='dark'] :is(.new-request-tab-header, .new-request-tab-state, .new-request-category-header, .new-request-process-card, .new-request-schedule-panel) {\n  background: #111827 !important;\n  border-color: #334155 !important;\n}\n\nhtml[data-theme='dark'] .new-request-tab-search {\n  background: #0f172a !important;\n  border-color: #334155 !important;\n}\n\nhtml[data-theme='dark'] .new-request-tab-shell :is(h1, h2, h3, p, label) {\n  color: #f8fafc !important;\n}\n\nhtml[data-theme='dark'] .new-request-process-card .text-slate-900,\nhtml[data-theme='dark'] .new-request-process-card .text-blue-600,\nhtml[data-theme='dark'] .new-request-tab-header .text-slate-900,\nhtml[data-theme='dark'] .new-request-category-header .text-slate-900,\nhtml[data-theme='dark'] .new-request-category-header .text-blue-500 {\n  color: #f8fafc !important;\n}\n\nhtml[data-theme='dark'] .new-request-process-card {\n  background: #0f1b33 !important;\n  border-color: #31425f !important;\n}\n\nhtml[data-theme='dark'] .new-request-process-card .new-request-process-id {\n  background: rgba(147, 197, 253, 0.22) !important;\n  color: #bfdbfe !important;\n}\n\nhtml[data-theme='dark'] .new-request-category-badge {\n  background: rgba(16, 185, 129, 0.2) !important;\n  border-color: rgba(110, 231, 183, 0.45) !important;\n  color: #bbf7d0 !important;\n}\n\n/* Form Builder dark theme readability */\nhtml[data-theme='dark'] .form-builder-page :is(\n  [class*='text-blue-'],\n  [class*='text-slate-9'],\n  [class*='text-slate-8'],\n  [class*='text-slate-7'],\n  [class*='text-slate-6'],\n  [class*='text-slate-5']\n) {\n  color: #f8fafc !important;\n}\n\nhtml[data-theme='dark'] .form-builder-page .form-builder-option-chip {\n  color: #1e3a8a !important;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
